import React, { useCallback, useEffect, useRef, useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useAuth } from "./AuthContext";
import "./App.css";
import HandleUser from "./components/HandleUser";
import TodoList from "./components/TodoList";
import Header from "./components/Header/Header";
import TopBar from "./components/TopBar/TopBar";
import Loader from "./components/Loader/Loader";
import Toast from "./components/Toast";

function App() {
  const { user, loading } = useAuth();
  const auth = getAuth();
  const [authToast, setAuthToast] = useState(null);
  const prevUserRef = useRef(undefined);

  useEffect(() => {
    if (loading) return;

    const prevUser = prevUserRef.current;
    if (prevUser !== undefined) {
      if (!prevUser && user) {
        setAuthToast({ message: 'Logged in successfully!', type: 'success' });
      } else if (prevUser && !user) {
        setAuthToast({ message: 'Logged out successfully!', type: 'info' });
      }
    }
    prevUserRef.current = user;
  }, [user, loading]);

  const handleSignOut = useCallback(async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Sign-out error:", error);
    }
  }, [auth]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {!user && <Header />}
      {user && <TopBar userEmail={user.email} handleSignOut={handleSignOut} />}
      <main className={user ? "main-withTodoList" : ""}>
        {!user ? <HandleUser /> : <TodoList userInfo={user} />}
      </main>
      {authToast && (
        <Toast
          message={authToast.message}
          type={authToast.type}
          onClose={() => setAuthToast(null)}
        />
      )}
    </>
  );
}

export default App;